import {nextTick} from "vue";
import scrollIntoView from 'scroll-into-view';

// const scrollIntoView = require('scroll-into-view');

const isElement = (obj) => {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  }
  catch(e){
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have (works on IE7)
    return (typeof obj==="object") &&
      (obj.nodeType===1) && (typeof obj.style === "object") &&
      (typeof obj.ownerDocument ==="object");
  }
}

export const scrollToElement = (id: any, duration = 500) => {
  try {
    if (!id || id == '') return;
    scrollIntoView(isElement(id) ? id : window.document.querySelector(id), {
      time: duration,
      cancellable: true
      // align: {
      //   // top: 0,
      //   // topOffset: 0
      // }
    })
  } catch (e) {
    // console.error(e);
  }
}

export const scrollToFormError = async (duration = 500) => {
  await nextTick();
  scrollToElement('.form-group-has-error', duration);
}
